import React from 'react';
import styled from 'styled-components';
import {
  alignItems,
  AlignItemsProps,
  justifyContent,
  JustifyContentProps,
  flex,
  FlexProps as CSSFlexProps,
  flexWrap,
  FlexWrapProps,
  flexDirection,
  FlexDirectionProps,
  alignSelf,
  AlignSelfProps,
} from 'styled-system';

import { Box, BoxProps } from '~/components/Box';

export type FlexProps = BoxProps &
  AlignItemsProps &
  AlignSelfProps &
  JustifyContentProps &
  CSSFlexProps &
  FlexDirectionProps &
  FlexWrapProps;

export const Flex = styled(Box)<FlexProps>`
  display: flex;

  ${flex};
  ${flexWrap};
  ${alignSelf};
  ${alignItems};
  ${flexDirection};
  ${justifyContent};
`;

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const FlexDocz = (props: FlexProps) => {
  return <Flex {...props} />;
};

Flex.defaultProps = {
  alignItems: 'center',
};
try {
    // @ts-ignore
    Flex.displayName = "Flex";
    // @ts-ignore
    Flex.__docgenInfo = { "description": "", "displayName": "Flex", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Flex/Flex.tsx#Flex"] = { docgenInfo: Flex.__docgenInfo, name: "Flex", path: "src/components/Flex/Flex.tsx#Flex" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    FlexDocz.displayName = "FlexDocz";
    // @ts-ignore
    FlexDocz.__docgenInfo = { "description": "", "displayName": "FlexDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Flex/Flex.tsx#FlexDocz"] = { docgenInfo: FlexDocz.__docgenInfo, name: "FlexDocz", path: "src/components/Flex/Flex.tsx#FlexDocz" };
}
catch (__react_docgen_typescript_loader_error) { }